<template>
  <v-form ref="payment_details">
    <v-layout row wrap>
      <v-flex xs12 class="pr-2">
        <v-text-field
          id="card_holder_name"
          color="secondary"
          :label="$t('payment_form.card_holder_name.title')"
          :placeholder="$t('payment_form.card_holder_name.placeholder')"
          name="card_holder_name"
          type="text"
          v-model="payment_method.billing_details.name"
        ></v-text-field>
          <v-text-field
          id="email"
          color="secondary"
          :label="$t('payment_form.email.title')"
          :placeholder="$t('payment_form.email.placeholder')"
          name="email"
          :rules="[rules.email]"
          type="text"
          v-model="payment_method.billing_details.email"
        ></v-text-field>
        <v-text-field
          id="card_number"
          color="secondary"
          :label="$t('payment_form.card_number.title')"
          :placeholder="$t('payment_form.card_number.placeholder')"
          name="card_number"
          :rules="[rules.required]"
          type="text"
          v-model="payment_method.card.number"
          mask="#### - #### - #### - ####"
        ></v-text-field>
      </v-flex>
      <v-flex xs12 md6 class="pr-2">
        <v-text-field
          id="card_expiry"
          color="secondary"
          :label="$t('payment_form.expiry.title')"
          name="card_expiry"
          :placeholder="$t('payment_form.expiry.placeholder')"
          :rules="[rules.required]"
          type="text"
          v-model="payment_method.card.expiry"
          v-cardformat:formatCardExpiry
        ></v-text-field>
      </v-flex>
      <v-flex xs12 md6 class="pl-2">
        <v-text-field
          id="cvv"
          color="secondary"
          :label="$t('payment_form.cvv.title')"
          name="cvv"
          :placeholder="$t('payment_form.cvv.placeholder')"
          :rules="[rules.required]"
          type="text"
          v-model="payment_method.card.cvc"
          v-cardformat:formatCardCVC
        ></v-text-field>
      </v-flex>
      <v-flex xs12 md6 class="pr-2">
        <v-text-field
          id="address"
          color="secondary"
          :label="$t('address.title')"
          name="address"
          :rules="[rules.required]"
          type="text"
          v-model="payment_method.billing_details.address.line1"
        ></v-text-field>
      </v-flex>
      <v-flex xs12 md6 class="pl-2">
        <v-text-field
          id="zip_code"
          color="secondary"
          :label="$t('zip_code.title')"
          name="zip_code"
          :rules="[rules.required,rules.alphaNumericCharacters]"
          type="text"
          v-model="payment_method.billing_details.address.postal_code"
        ></v-text-field>
      </v-flex>
    </v-layout>
  </v-form>
</template>

<script>
import rules from "@/validation";

export default {
  name: "PaymentForm",
  props: [],
  data() {
    return {
      rules,
      // Payment Details
      payment_method: {
        type: "card",
        card: {
          number: null,
          cvc: null,
          expiry: null,
        },
        billing_details: {
          address: {
            line1: "",
            postal_code: "",
          },
          name:null,
          email:null
        },
      },
    };
  },
  watch: {
    payment_method: {
      handler: function () {
        this.$emit("update:payment_method", this.payment_method);
      },
      deep: true,
    },
  },
  methods: {
    reset() {
      this.$refs.payment_details.reset();
    },
    validate() {
      return this.$refs.payment_details.validate();
    },
  },
};
</script>

<style></style>
